module.exports = require("commonmark");


//////////////////
// WEBPACK FOOTER
// external "commonmark"
// module id = 520
// module chunks = 0